import { useToggle } from "utils/Hooks"
import { FleContinueWrapper, FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { LeftArrow, ContinueArrow, Skip } from "components/views/fle/Molecules"
import React from "react"
import { BodySmall } from "../../atoms/Bodies"
import { Checkbox } from "../../atoms/Checkbox"
import { IlloPaperAirplane } from "../../atoms/Illustrations"
import { TextLink } from "../../atoms/links/TextLink"
import FLEInformationModal from "../../modal/FLEInformationModal"
import L10n from "lib/carrot-l10n"
import { H1, FlexContainer, Container, Body, Stack } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const EmailOptIn = ({ emailOptIn, setEmailOptIn, onBack, onComplete, benefitConfiguration }) => {
  const [showPrivacyPolicyModal, togglePrivacyPolicyModal] = useToggle(false)

  return (
    <FleLayout
      bottomContent={
        <FleContinueWrapper>
          <Skip onClick={onComplete} />
          <ContinueArrow onClick={onComplete} />
        </FleContinueWrapper>
      }
    >
      <TopSection showProgressTracker={false} progressStep={1} leftOrBackArrow={<LeftArrow onClick={onBack} />} />
      <FlexContainer justifyContent="center" stack="medium">
        <IlloPaperAirplane />
      </FlexContainer>
      <H1 variant="primary" stack="tiny">
        Stay updated
      </H1>
      <Container stack="medium">
        <Body color="black-80">
          {l`We’ll share occasional updates about your Carrot benefit, such as new features and partnerships, as well as 
        member-only expert resources.`}
        </Body>
      </Container>
      <label>
        <Stack direction="row" spacing="10px">
          <Checkbox checked={emailOptIn} onChange={(e) => setEmailOptIn(e.target.checked)} />
          <Stack spacing="small" width={["356px", "456px"]}>
            <Body>Yes, keep me updated.</Body>
            <BodySmall>
              We will protect your data and keep your information confidential in accordance with our&nbsp;
              <TextLink underlineColor="black-80" onClick={togglePrivacyPolicyModal}>
                {l`fle2.privacyPolicy`}
              </TextLink>
              . You can unsubscribe at any time in your account settings.
            </BodySmall>
          </Stack>
        </Stack>
      </label>
      {showPrivacyPolicyModal ? (
        <FLEInformationModal
          onClose={togglePrivacyPolicyModal}
          header={l`fle2.privacyPolicy`}
          source={l`fle2.privacyPolicyFull`}
          benefitConfiguration={benefitConfiguration}
          showInDesktopView
          isTCPPModal
        />
      ) : null}
    </FleLayout>
  )
}
